



































import { Component, Prop, Vue } from 'vue-property-decorator'

import { ListItem } from '@/layouts/components'

import { Order, OrderItem, OrderOption, OrderStatus } from '@/models'

@Component({
  components: {
    ListItem
  }
})
export default class OrderItemTile extends Vue {
  @Prop({ type: Object, required: true })
  readonly order!: Order

  @Prop({ type: Object, required: true })
  readonly item!: OrderItem

  @Prop({ type: Boolean, default: false })
  readonly showPrice!: boolean

  get hasPortion () {
    return this.item.portion !== null
  }

  get isCanceled () {
    return this.order.status === OrderStatus.CANCELED
  }

  optionKey (option: OrderOption, field: string): string {
    return `${this.order.id}__${this.item.id}_${this.item.quantity}_${this.item.total}__${option.id}__${field}`
  }
}
